var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlippedTriCube = function SvgFlippedTriCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 52.756 30.098-17.252 30.097 17.252-30.097 17.252L1 52.756Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.004 52.756 30.098-17.252V1L1.004 18.252v34.504Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.098 35.504 30.097 17.252V18.252L31.098 1v34.504Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m31.098 70.007 30.097-17.252V18.251L31.098 35.503v34.504Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.102 70.007 1.004 52.755V18.251l30.098 17.252v34.504Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.252 31.098 1l30.097 17.252-30.097 17.252L1 18.252Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m60.805 52.756 30.097-17.252L121 52.756 90.902 70.008 60.805 52.756Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m60.809 52.756 30.097-17.252V1L60.808 18.252v34.504Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.902 35.504 121 52.756V18.252L90.902 1v34.504Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.902 70.007 121 52.755V18.251L90.902 35.503v34.504Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.906 70.007 60.808 52.755V18.251l30.098 17.252v34.504Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.805 18.252 90.902 1 121 18.252 90.902 35.504 60.805 18.252Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m30.914 104.747 30.098-17.252 30.097 17.252-30.097 17.252-30.098-17.252Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m30.918 104.747 30.098-17.252V52.991L30.918 70.243v34.504Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m61.012 87.495 30.097 17.252V70.243L61.012 52.991v34.504Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m61.012 121.998 30.097-17.252V70.242L61.012 87.494v34.504Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m61.016 121.998-30.098-17.252V70.242l30.098 17.252v34.504Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m30.914 70.243 30.098-17.252 30.097 17.252-30.097 17.252-30.098-17.252Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })));
};
export { SvgFlippedTriCube as ReactComponent };
export default "data:image/svg+xml;base64,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";